import React from 'react';
import { useParams } from 'react-router-dom';
import { useLazyQuery } from 'apollo-client-ppc';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { NoData } from '@css-xp/ppc-common';
import {
  FetchIGPurchaseOrderInPpcQuery,
  FetchIGPurchaseOrderInPpcQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchIGPurchaseOrderInPPC } from '../queries/fetch-ig-purchase-order';

interface QuotePurchaseOrderProps {
  invoiceGroupId: string;
}

export const QuotePurchaseOrder = ({ invoiceGroupId }: QuotePurchaseOrderProps) => {
  const { txaId } = useParams<{ txaId: string }>();
  const client = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);

  const [fetchInvoiceGroupDetails, { data: invoiceGroupDetails, loading: isPONumberLoading }] = useLazyQuery<
    FetchIGPurchaseOrderInPpcQuery,
    FetchIGPurchaseOrderInPpcQueryVariables
  >(fetchIGPurchaseOrderInPPC, {
    client: client as any,
  });

  React.useEffect(() => {
    if (invoiceGroupId) {
      fetchInvoiceGroupDetails({
        variables: {
          id: invoiceGroupId,
          txaId,
        },
      });
    }
  }, [invoiceGroupId]);

  return isPONumberLoading ? (
    <SkeletonLoaderWrapper>
      <SkeletonLoader width="60%" marginBottom="0" />
    </SkeletonLoaderWrapper>
  ) : (
    <>{invoiceGroupDetails?.invoiceGroup?.purchaseOrder?.number ?? <NoData />}</>
  );
};
